import { OperatingExpenseCalculatedOn } from 'views/ProFormaWizard/constants';

/* eslint-disable no-unused-vars */
export interface IOtherIncome {
    id: number;
    name: string;
    annualGrowth?: number;
    valuePerUnitPerMonth?: number;
    amountPerYear?: number;
    percentageOfTotalRentalIncome: number;
    calculatedOn?: string;
}

export interface IUnitMix {
    id: number;
    name: string;
    amountPerMonth?: number;
    bedrooms?: number;
    bathrooms?: number;
    averageSquareFootage?: number;
    units?: number;
    totalRent?: number;
}

export interface ITenant {
    id: number;
    name: string;
    units?: number;
    averageSquareFootage?: number;
    amountPerMonth?: number;
    totalRent?: number;
    rentGrowth?: number;
    rentSfYear?: number;
    proRata?: number;
    recoveryIncome: number;
    leaseStartDate?: Date;
    rentStartDate?: Date;
    recoveryStartDate?: Date;
}

export enum ExpenseType {
    UNITS = 'units',
    SF = 'sf'
}

export const COST_TYPES = [
    { label: 'per unit', value: ExpenseType.UNITS },
    { label: 'per sf', value: ExpenseType.SF },
];

export interface IExpenses {
    expenses: number;
    valuePerUnitPerYear?: number;
    valuePerSfPerYear?: number;
    amountPerYear: number;
    expensesType: ExpenseType;
    calculatedOn?: OperatingExpenseCalculatedOn;
    isDeleteAllowed?: boolean;
}

export type TUnit = IUnitMix | ITenant;
